import register from '@kpsys/angularjs-register';
import ServerUrlsDataService from './server-urls.data-service';
import ModalConversationInterceptorService from './modal-conversation-interceptor.service';
import {CatalogueSelectionLoginListener} from './catalogue-selection-login.listener';
import {SearchSelectionModalService} from './search-selection-modal/search-selection-modal.service';
import {KpUserPreferencesModalService} from './user-preferences-modal/kp-user-preferences-modal.service';
import {KpRecordEditationModalService} from './record-editation-modal/kp-record-editation-modal.service';
import {FilesSelectionModalService} from './files-selection-modal/files-selection-modal.service';
import {UserFilesUploadModalPresenter} from './user-files-upload-modal/user-files-upload-modal.presenter';
import {DiscountRequestModalPresenter} from './discount-request-modal/discount-request-modal.presenter';
import {LoanRequestFormService} from './loan-request-form/loan-request-form.service';
import {DepartmentCreatedModalService} from './department-created-modal/department-created-modal.service';

/**
 * @ngdoc module
 * @module portaro.modals
 * @name portaro.modals
 */
export default register('portaro.modals')
    .service(ModalConversationInterceptorService.serviceName, ModalConversationInterceptorService)
    .service(CatalogueSelectionLoginListener.serviceName, CatalogueSelectionLoginListener)
    .service(ServerUrlsDataService.serviceName, ServerUrlsDataService)
    // Modals already refactored into Svelte
    .service(DepartmentCreatedModalService.serviceName, DepartmentCreatedModalService)
    .service(SearchSelectionModalService.serviceName, SearchSelectionModalService)
    .service(KpUserPreferencesModalService.serviceName, KpUserPreferencesModalService)
    .service(KpRecordEditationModalService.serviceName, KpRecordEditationModalService)
    .service(FilesSelectionModalService.serviceName, FilesSelectionModalService)
    .service(UserFilesUploadModalPresenter.presenterName, UserFilesUploadModalPresenter)
    .service(DiscountRequestModalPresenter.presenterName, DiscountRequestModalPresenter)
    .service(LoanRequestFormService.serviceName, LoanRequestFormService)
    .name();